import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { yellow, blueGrey } from "@mui/material/colors";
import { formatNumber, getYearMonthDateDisplay } from "../../utils/utils";
const infoTableCellSx = {
  fontSize: 17,
};
const TransactionTableItem = (props) => {
  const { data, index, selectTransaction } = props;

  function handleClickItem() {
    selectTransaction.setValue(data);
  }

  const isSelectingTransaction =
    data.paymentId === (selectTransaction?.Value?.paymentId || null) ||
    data.receiptId === (selectTransaction?.Value?.receiptId || null);

  return (
    <TableRow
      key={index}
      sx={{
        "&:hover": {
          backgroundColor: blueGrey[50],
          cursor: "pointer",
        },
        backgroundColor: isSelectingTransaction ? yellow[100] : "white",
      }}
      onClick={handleClickItem}
    >
      {/*No  */}
      <TableCell sx={{ ...infoTableCellSx, width: 50 }}>{index + 1}</TableCell>
      {/* 入金元 */}
      <TableCell sx={{ ...infoTableCellSx, width: 500, textAlign: "left" }}>
        {`${data.partnerNo}${data.partnerName ? " - " + data.partnerName : ""}`}
      </TableCell>
      {/* 区分 */}
      <TableCell sx={{ ...infoTableCellSx, width: 100, textAlign: "right" }}>
        {data.divisionCd}
      </TableCell>
      {/* 金額 */}
      <TableCell sx={{ ...infoTableCellSx, width: 100, textAlign: "right" }}>
        {formatNumber(data.amount)}
      </TableCell>
      {/* 科目 */}
      <TableCell sx={{ ...infoTableCellSx, width: 100, textAlign: "right" }}>
        {data.subjectCd}
      </TableCell>
      {/* 担当 */}
      <TableCell sx={{ ...infoTableCellSx, width: 100, textAlign: "right" }}>
        {data.staffId}
      </TableCell>
      {/* 日付 */}
      <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
        {getYearMonthDateDisplay(new Date(data.transactionDate))}
      </TableCell>
    </TableRow>
  );
};

export default TransactionTableItem;
